import type {
  GetCredentialsResponse,
  MerchantExternalCredential,
} from '../store/modules/merchant/types';

type CredentialGroup = Exclude<keyof GetCredentialsResponse, 'merchantId'>;

/** The credential `externalCredentials[type]` points at, which MMS and ecom-connector use. */
export const findDefaultCredential = (
  credentials: GetCredentialsResponse | undefined,
  type: CredentialGroup,
): MerchantExternalCredential | undefined => {
  const group = credentials?.[type];
  return group?.default
    ? group.credentials.find((credential) => credential.credentialId === group.default)
    : undefined;
};
